import { defineMessages } from "react-intl";

export default defineMessages({
  noSuchCourse: {
    id: "pages.courseSingle.noSuchCourse",
    defaultMessage: "This course does not exist or is not published",
    description: "Message shown when course doesn't exist",
  },
  descriptionTitle: {
    id: "pages.courseSingle.descriptionTitle",
    defaultMessage: "Description",
    description: "Description title",
  },
  noDescriptionFound: {
    id: "pages.courseSingle.noDescriptionFound",
    defaultMessage: "No description found",
    description: "No description found",
  },
  contentsTitle: {
    id: "pages.courseSingle.contentsTitle",
    defaultMessage: "Contents",
    description: "Contents title",
  },
  noContentsFound: {
    id: "pages.courseSingle.noContentsFound",
    defaultMessage: "No contents found",
    description: "No contents found",
  },
  addToCart: {
    id: "pages.courseSingle.addToCart",
    defaultMessage: "Add to Cart",
    description: "Add to Cart button",
  },
  removeFromCart: {
    id: "pages.courseSingle.removeFromCart",
    defaultMessage: "Remove from Cart",
    description: "Remove from Cart button",
  },
  addToWishlist: {
    id: "pages.courseSingle.addToWishlist",
    defaultMessage: "Add to Wishlist",
    description: "Add to Wishlist button",
  },
  removeFromWishlist: {
    id: "pages.courseSingle.removeFromWishlist",
    defaultMessage: "Remove from Wishlist",
    description: "Remove from Wishlist button",
  },
  loading: {
    id: 'course.single.loading',
    defaultMessage: 'Loading course information...',
    description: 'Message shown while course data is being loaded',
  },
  overviewTitle: {
    id: "pages.courseSingle.overviewTitle",
    defaultMessage: "Overview",
    description: "Title for overview section",
  },
  showMore: {
    id: "pages.courseSingle.showMore",
    defaultMessage: "Show More",
    description: "Button text to show more content"
  },
  showLess: {
    id: "pages.courseSingle.showLess",
    defaultMessage: "Show Less",
    description: "Button text to show less content"
  },
});
